import { add, formatISO } from 'date-fns';

export const getStartAndEndDate = ({
  pageNumber,
  pageSize,
}: {
  pageNumber: number;
  pageSize: number;
}) => {
  const startDate = add(new Date(), {
    days: 1,
  }).setHours(0, 0, 0);

  return {
    startDate: formatISO(
      add(startDate, {
        days: (pageNumber - 1) * pageSize,
      }),
    ),
    endDate: formatISO(
      add(startDate, {
        days: (pageNumber - 1) * pageSize + (pageSize - 1) + 1,
      }),
    ),
  };
};
